// extracted by mini-css-extract-plugin
export default {"obrazek":"AnnouncementModal_obrazek__jnE2v"};